// Per-user UI translations. Add new languages by adding a dictionary below.
import { useAuth } from "@/context/AuthContext";

export const LANGUAGES = [
  { code: "en", label: "English" },
  { code: "es", label: "Español" },
];

const dict = {
  en: {
    nav_new_count: "New Count",
    nav_history: "History",
    nav_employees: "Employees",
    nav_settings: "Settings",
    starting_amount: "Starting Amount",
    starting_sub: "Enter the actual cash in the drawer at the start of the shift.",
    employee: "Employee",
    select_employee: "Select employee",
    no_employees: "No employees yet",
    starting_drawer: "Starting Drawer",
    bills: "Bills",
    coins: "Coins",
    starting_bills: "Starting Bills",
    starting_coins: "Starting Coins",
    count_closing_drawer: "Count Closing Drawer",
    add_employee: "Add Employee",
    employee_name_ph: "Employee name",
    add: "Add",
    counting_for: "Counting Closing Drawer For:",
    clear: "Clear",
    expected_cash_ticket: "Expected Cash (Ticket)",
    payouts_removed: "Payouts / Cash Removed",
    subtracted_note: "Subtracted from expected drawer",
    add_payout: "Add Payout",
    expected_cash: "Expected Cash",
    payouts: "Payouts",
    expected_drawer: "Expected Drawer",
    closing_count: "Closing Count",
    closing_sub: "Enter the NUMBER of each bill and coin in the drawer.",
    total_bills_counted: "Total Bills Counted",
    total_coins_counted: "Total Coins Counted",
    total_cash_counted: "Total Cash Counted",
    deposit_amount: "Deposit Amount",
    starting_bills_returned: "Starting Bills Returned",
    amount_to_be_deposited: "Amount to be Deposited",
    drawer_reconciliation: "Drawer Reconciliation",
    over_short: "Over / Short",
    balanced: "Balanced",
    notes_optional: "Notes (optional)",
    notes_ph: "Anything worth remembering about this count...",
    save_count: "Save Count",
    clear_title: "Clear Closing Drawer Count?",
    clear_desc: "This will clear all information entered for this drawer count.",
    cancel: "Cancel",
    language: "Language",
    choose_language: "Choose Language",
    translate: "Translate",
    view_original: "View Original",
    translating: "Translating...",
    penny: "Pennies", nickel: "Nickels", dime: "Dimes", quarter: "Quarters",
    business: "Business", business_name_label: "Business Name",
    invite_users: "Invite Users", generate_invite: "Generate Invitation Link",
    team: "Team", record_retention: "Record Retention", your_profile: "Your Profile",
    change_password: "Change Password", danger_zone: "Danger Zone",
    save: "Save", history_title: "History", employees_title: "Employees", login_title: "Log in",
    // Status labels
    status_balanced: "BALANCED", status_short: "SHORT", status_over: "OVER",
    // Settings
    settings_subtitle: "Manage your business, team, and saved counts.",
    shared_everyone: "Shared with everyone in your business.",
    invite_generate_desc: "Generate a secure link to invite teammates to",
    invite_anyone_join: "Anyone with this link can create their own login and join",
    regenerate: "Regenerate", revoke: "Revoke",
    keep_all_records: "Keep all records", keep_all_records_desc: "Never delete saved counts.",
    auto_delete_weekly: "Auto-delete weekly", auto_delete_weekly_desc: "Remove counts older than 7 days.",
    auto_delete_monthly: "Auto-delete monthly", auto_delete_monthly_desc: "Remove counts older than 30 days.",
    custom: "Custom", custom_desc: "Remove counts older than a set number of days.",
    delete_after: "Delete after", days: "days",
    save_settings: "Save Settings",
    lang_applies_note: "Applies only to your account, not your teammates.",
    current_password: "Current Password", new_password: "New Password",
    confirm_new_password: "Confirm New Password", at_least_6: "At least 6 characters",
    update_password: "Update Password",
    your_name: "Your Name", add_your_name: "Add your name",
    profile_name_note: "Shown on your saved counts and the team list. Leave blank to show your email instead.",
    signed_in_as: "Signed in as", log_out: "Log out", you_badge: "You",
    leave_business: "Leave this business",
    leave_business_desc: "Removes only your access. The business and its data stay for the rest of the team.",
    leave: "Leave", delete: "Delete", remove: "Remove",
    delete_business: "Delete this business",
    delete_business_desc_pre: "Permanently deletes",
    delete_business_desc_post: ", every user, and all saved counts. This cannot be undone.",
    remove_self_desc: "This removes your own access and logs you out. You'll need a new invitation to rejoin.",
    remove_other_desc: "This user will lose access to the shared business. This cannot be undone.",
    leave_q_pre: "Leave",
    leave_confirm_desc: "This removes only your access and logs you out. You'll need a new invitation link to rejoin.",
    delete_q_pre: "Delete",
    delete_confirm_desc: "This permanently deletes the business, every user account, and all saved counts. This cannot be undone. Enter your password to confirm.",
    your_password: "Your password", delete_business_btn: "Delete Business",
    // History
    history_subtitle: "Saved drawer counts.",
    all_employees: "All employees", counted_by_anyone: "Counted by anyone",
    no_counts_yet: "No counts yet", saved_counts_appear: "Saved counts will appear here.",
    no_matching_counts: "No matching counts", try_different_filters: "Try different filters.",
    deposits: "Deposits", net: "Net", deposit_word: "Deposit",
    // CountDetail
    notes: "Notes", count_not_found: "Count not found.", back_to_history: "Back to History",
    counted_by: "Counted by", coins_remaining: "Coins Remaining in Drawer",
    denomination_breakdown: "Denomination Breakdown",
    starting_word: "Starting", closing_word: "Closing",
    // Employees
    employees_subtitle: "Manage the names you count drawers for.",
    new_employee_name: "New employee name",
    no_employees_add: "No employees yet. Add one above.",
    remove_employee_desc: "This removes the employee from the list. Saved counts are not affected.",
    adjustment_desc_ph: "Description (e.g. Employee Pay)",
  },
  es: {
    nav_new_count: "Conteo Nuevo",
    nav_history: "Historial",
    nav_employees: "Empleados",
    nav_settings: "Ajustes",
    starting_amount: "Monto Inicial",
    starting_sub: "Ingresa el efectivo real en la caja al inicio del turno.",
    employee: "Empleado",
    select_employee: "Selecciona empleado",
    no_employees: "Aún no hay empleados",
    starting_drawer: "Caja Inicial",
    bills: "Billetes",
    coins: "Monedas",
    starting_bills: "Billetes Iniciales",
    starting_coins: "Monedas Iniciales",
    count_closing_drawer: "Contar Caja de Cierre",
    add_employee: "Agregar Empleado",
    employee_name_ph: "Nombre del empleado",
    add: "Agregar",
    counting_for: "Contando Caja de Cierre Para:",
    clear: "Borrar",
    expected_cash_ticket: "Efectivo Esperado (Ticket)",
    payouts_removed: "Pagos / Efectivo Retirado",
    subtracted_note: "Se resta de la caja esperada",
    add_payout: "Agregar Pago",
    expected_cash: "Efectivo Esperado",
    payouts: "Pagos",
    expected_drawer: "Caja Esperada",
    closing_count: "Conteo de Cierre",
    closing_sub: "Ingresa la CANTIDAD de cada billete y moneda en la caja.",
    total_bills_counted: "Total de Billetes Contados",
    total_coins_counted: "Total de Monedas Contadas",
    total_cash_counted: "Total de Efectivo Contado",
    deposit_amount: "Monto del Depósito",
    starting_bills_returned: "Billetes Iniciales Devueltos",
    amount_to_be_deposited: "Monto a Depositar",
    drawer_reconciliation: "Reconciliación de Caja",
    over_short: "Sobra / Falta",
    balanced: "Cuadrado",
    notes_optional: "Notas (opcional)",
    notes_ph: "Algo que valga la pena recordar sobre este conteo...",
    save_count: "Guardar Conteo",
    clear_title: "¿Borrar el conteo de la caja de cierre?",
    clear_desc: "Esto borrará toda la información ingresada para este conteo.",
    cancel: "Cancelar",
    language: "Idioma",
    choose_language: "Elige Idioma",
    translate: "Traducir",
    view_original: "Ver Original",
    translating: "Traduciendo...",
    penny: "Centavos", nickel: "Cinco Centavos", dime: "Diez Centavos", quarter: "Veinticinco Centavos",
    business: "Negocio", business_name_label: "Nombre del Negocio",
    invite_users: "Invitar Usuarios", generate_invite: "Generar Enlace de Invitación",
    team: "Equipo", record_retention: "Retención de Registros", your_profile: "Tu Perfil",
    change_password: "Cambiar Contraseña", danger_zone: "Zona de Peligro",
    save: "Guardar", history_title: "Historial", employees_title: "Empleados", login_title: "Iniciar Sesión",
    // Status labels
    status_balanced: "CUADRADO", status_short: "FALTA", status_over: "SOBRA",
    // Settings
    settings_subtitle: "Administra tu negocio, equipo y conteos guardados.",
    shared_everyone: "Compartido con todos en tu negocio.",
    invite_generate_desc: "Genera un enlace seguro para invitar compañeros a",
    invite_anyone_join: "Cualquiera con este enlace puede crear su propio acceso y unirse a",
    regenerate: "Regenerar", revoke: "Revocar",
    keep_all_records: "Conservar todos los registros", keep_all_records_desc: "Nunca eliminar los conteos guardados.",
    auto_delete_weekly: "Eliminar cada semana", auto_delete_weekly_desc: "Eliminar conteos de más de 7 días.",
    auto_delete_monthly: "Eliminar cada mes", auto_delete_monthly_desc: "Eliminar conteos de más de 30 días.",
    custom: "Personalizado", custom_desc: "Eliminar conteos con más de cierto número de días.",
    delete_after: "Eliminar después de", days: "días",
    save_settings: "Guardar Ajustes",
    lang_applies_note: "Se aplica solo a tu cuenta, no a tus compañeros.",
    current_password: "Contraseña Actual", new_password: "Nueva Contraseña",
    confirm_new_password: "Confirmar Nueva Contraseña", at_least_6: "Al menos 6 caracteres",
    update_password: "Actualizar Contraseña",
    your_name: "Tu Nombre", add_your_name: "Agrega tu nombre",
    profile_name_note: "Se muestra en tus conteos guardados y la lista del equipo. Déjalo en blanco para mostrar tu correo.",
    signed_in_as: "Sesión iniciada como", log_out: "Cerrar Sesión", you_badge: "Tú",
    leave_business: "Salir de este negocio",
    leave_business_desc: "Elimina solo tu acceso. El negocio y sus datos permanecen para el resto del equipo.",
    leave: "Salir", delete: "Eliminar", remove: "Eliminar",
    delete_business: "Eliminar este negocio",
    delete_business_desc_pre: "Elimina permanentemente",
    delete_business_desc_post: ", cada usuario y todos los conteos guardados. Esto no se puede deshacer.",
    remove_self_desc: "Esto elimina tu propio acceso y cierra tu sesión. Necesitarás una nueva invitación para volver a unirte.",
    remove_other_desc: "Este usuario perderá acceso al negocio compartido. Esto no se puede deshacer.",
    leave_q_pre: "¿Salir de",
    leave_confirm_desc: "Esto elimina solo tu acceso y cierra tu sesión. Necesitarás un nuevo enlace de invitación para volver a unirte.",
    delete_q_pre: "¿Eliminar",
    delete_confirm_desc: "Esto elimina permanentemente el negocio, cada cuenta de usuario y todos los conteos guardados. Esto no se puede deshacer. Ingresa tu contraseña para confirmar.",
    your_password: "Tu contraseña", delete_business_btn: "Eliminar Negocio",
    // History
    history_subtitle: "Conteos de caja guardados.",
    all_employees: "Todos los empleados", counted_by_anyone: "Contado por cualquiera",
    no_counts_yet: "Aún no hay conteos", saved_counts_appear: "Los conteos guardados aparecerán aquí.",
    no_matching_counts: "No hay conteos coincidentes", try_different_filters: "Prueba con otros filtros.",
    deposits: "Depósitos", net: "Neto", deposit_word: "Depósito",
    // CountDetail
    notes: "Notas", count_not_found: "Conteo no encontrado.", back_to_history: "Volver al Historial",
    counted_by: "Contado por", coins_remaining: "Monedas Restantes en la Caja",
    denomination_breakdown: "Desglose de Denominaciones",
    starting_word: "Inicial", closing_word: "Cierre",
    // Employees
    employees_subtitle: "Administra los nombres para los que cuentas cajas.",
    new_employee_name: "Nombre del nuevo empleado",
    no_employees_add: "Aún no hay empleados. Agrega uno arriba.",
    remove_employee_desc: "Esto elimina al empleado de la lista. Los conteos guardados no se ven afectados.",
    adjustment_desc_ph: "Descripción (ej. Pago a Empleado)",
  },
};

export function translate(lang, key) {
  const l = dict[lang] ? lang : "en";
  return (dict[l] && dict[l][key]) || dict.en[key] || key;
}

export function useT() {
  const { user } = useAuth();
  const lang = (user && user.language) || "en";
  return (key) => translate(lang, key);
}

// Localised status label (BALANCED/SHORT/OVER) for a given translator.
export function statusLabel(t, status) {
  if (status === "SHORT") return t("status_short");
  if (status === "OVER") return t("status_over");
  return t("status_balanced");
}
